/**
 * @author: Abdul Pathan
 */
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Col, Container, Form, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import schoolApi from "../../api/schoolApi";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import reportCardApi from "../reportCard/reportCardApi";

const AddClass = (props) => {
  const [rowRecord, setRowRecord] = useState({
    classname: "",
    category: "",
    aliasname: "",
    status: "active",
  });
  const [errorClassname, setErrorClassname] = useState("");
  const [allClasses, setAllClasses] = useState([]);

  // for "Promoted to Class" on the report card
  useEffect(() => {
    reportCardApi.activeClasses().then(setAllClasses).catch(() => setAllClasses([]));
  }, []);

  useEffect(() => {
    if (props?.parent?.class_id) {
      setRowRecord(props?.parent);
    }
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "classname") {
      setErrorClassname("");
    }
    setRowRecord({ ...rowRecord, [e.target.name]: e.target.value });
  };

  const isDuplicateClass = (classNameToTest, currentClassId) => {
    if (!classNameToTest || !props?.existingClasses || !Array.isArray(props?.existingClasses)) {
      return false;
    }
    const cleanTargetRaw = classNameToTest.trim().toLowerCase();
    const cleanTargetBase = cleanTargetRaw.split("[")[0].trim();

    return props.existingClasses.some((item) => {
      if (currentClassId && (item.class_id === currentClassId || item.id === currentClassId)) {
        return false;
      }
      const existingFull = (item.classname || "").trim().toLowerCase();
      const existingBase = existingFull.split("[")[0].trim();
      return (
        existingBase === cleanTargetBase ||
        existingFull === cleanTargetRaw ||
        existingBase === cleanTargetRaw ||
        existingFull === cleanTargetBase
      );
    });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const currentClassId = props?.parent?.class_id || props?.parent?.id;
      const targetClassName = rowRecord.classname?.trim();

      if (!targetClassName) {
        setErrorClassname("Class Name is required.");
        toast.error("Please enter Class Name");
        return;
      }

      if (isDuplicateClass(targetClassName, currentClassId)) {
        setErrorClassname(`Class '${targetClassName}' already exists.`);
        toast.error(`Class '${targetClassName}' already exists. Please choose a different name.`);
        return;
      }

      if (props?.parent?.class_id) {
        const editRecord = {
          id: props?.parent?.class_id,
          category: rowRecord.category,
          classname: targetClassName,
          aliasname: rowRecord.aliasname ? rowRecord.aliasname.trim() : "",
          status: rowRecord.status,
          next_class_id: rowRecord.next_class_id || "",
        };
       
        if (
          editRecord.status &&
          editRecord.status.trim() !== "" &&
          editRecord.category &&
          editRecord.category.trim() !== "" &&
          editRecord.classname &&
          editRecord.classname.trim() !== ""
        ) {
          let response = await schoolApi.updateClassRecord(editRecord);
          console.log('response-update->', response);
         
          if (response.success) {
            toast.success("Record updated successfully!");
            recordSaveSuccesfully();
          } else {
            toast.error(response.message || "Failed to update record");
          }
        } else {
          toast.error("Missing required fields");
          if (!rowRecord?.status || rowRecord?.status === "") {
            toast.error("Please Select Status");
          }
        }
      } else {
        if (
          rowRecord.classname &&
          rowRecord.classname.trim() !== "" &&
          rowRecord.status &&
          rowRecord.category &&
          rowRecord.category.trim() !== "" &&
          rowRecord.status.trim() !== ""
        ) {
          let response = await schoolApi.addClassRecord(rowRecord);
          if (response.success) {
            toast.success("Record saved successfully!");
            recordSaveSuccesfully();
          } else {
            toast.error(response.message || "Failed to save record");
          }
        } else {
          toast.error("Missing required fields");
        }
      }
    } catch (error) {
      console.log('error-->', error);
      const errMsg = error?.response?.data?.message || error?.message || "Record already exists or failed to save.";
      if (errMsg.toLowerCase().includes("already exists")) {
        setErrorClassname(errMsg);
      }
      toast.error(errMsg);
    }
  };
  const recordSaveSuccesfully = () => {
    props.recordSaveSuccesfully();
  };

  return (
    <Modal
      show={props.show}
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-dialog-scrollable"
      centered
    >
      <Modal.Header closeButton onClick={props.onHide}>
        <Modal.Title id="contained-modal-title-vcenter">
          Class Record
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form noValidate>
                <Row className="pb-4">
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Class Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="classname"
                        placeholder="--Class Name--"
                        value={rowRecord.classname}
                        onChange={handleChange}
                        isInvalid={!!errorClassname}
                      />
                      {errorClassname && (
                        <Form.Control.Feedback type="invalid" className="d-block">
                          {errorClassname}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label className="form-view-label">
                        Category
                      </Form.Label>
                      <Form.Select
                        required
                        name="category"
                        onChange={handleChange}
                        value={rowRecord.category}
                      >
                        <option value="">--Select Category--</option>
                        <option value="Pre-Primary">Pre-Primary</option>
                        <option value="Primary">Primary</option>
                        <option value="Secondary">Secondary</option>
                        <option value="Higher-Secondary">
                          Higher-Secondary
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="my-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Alias Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="aliasname"
                        placeholder="--Alias Name--"
                        value={rowRecord.aliasname}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Status
                      </Form.Label>
                      <Form.Select
                        required
                        name="status"
                        value={rowRecord.status}
                        onChange={handleChange}
                      >
                        <option value="">--None--</option>
                        <option value="active" aria-selected>
                          Active
                        </option>
                        <option value="inactive">Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label className="form-view-label">
                        Promoted to Class
                      </Form.Label>
                      <Form.Select
                        name="next_class_id"
                        value={rowRecord.next_class_id || ""}
                        onChange={handleChange}
                      >
                        <option value="">--None (last class)--</option>
                        {allClasses
                          .filter(
                            (c) =>
                              c.id !== (props?.parent?.class_id || props?.parent?.id)
                          )
                          .map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.class_name || c.classname}
                            </option>
                          ))}
                      </Form.Select>
                      <Form.Text muted>Printed on the report card when the student passes.</Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleSubmit}>
          {props?.parent?.id ? "Update" : "Save"}
        </Button>
        <Button onClick={props.onHide} variant="light">
          Close
        </Button>
      </Modal.Footer>
      {/* <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}
    </Modal>
  );
};

export default AddClass;
